/* Alemar motion layer. No dependencies. Safe if any selector is missing. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;

  /* ---------- 1. stagger targets for the scroll reveal ---------- */
  var GROUPS = [
    '.section > .container > *',
    '.grid > *',
    '.car__item',
    '.deals__grid > *',
    '.hero__inner > *'
  ];
  GROUPS.forEach(function (sel) {
    document.querySelectorAll(sel).forEach(function (el) {
      if (el.closest('.rake')) return;
      el.setAttribute('data-rv', '');
    });
  });
  // stagger siblings so rows cascade rather than pop together
  document.querySelectorAll('.grid, .deals__grid, .car__track, .hero__inner').forEach(function (wrap) {
    var i = 0;
    Array.prototype.forEach.call(wrap.children, function (c) {
      if (c.hasAttribute && c.hasAttribute('data-rv')) {
        c.style.setProperty('--rvd', (i * 85) + 'ms'); i++;
      }
    });
  });

  /* threshold 0: reveal as soon as any part of an element is on screen.
     A ratio threshold (was 0.06) never fires for blocks taller than the
     screen allows, e.g. the 85-scent Trio picker on phones (13 Oct 2026). */
  var revealIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('rv-in'); revealIO.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
  document.querySelectorAll('[data-rv]').forEach(function (el) { revealIO.observe(el); });

  /* ---------- 2. the raking light ---------- */
  var SECTIONS = document.querySelectorAll('.section, .deals, .carousel-section, .hero');
  SECTIONS.forEach(function (s) {
    if (s.querySelector(':scope > .rake')) return;
    var r = document.createElement('div');
    r.className = 'rake';
    s.appendChild(r);
  });
  /* same reason: a margin, not a ratio, so very tall sections still get their light */
  var rakeIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var r = e.target.querySelector(':scope > .rake');
      if (r) { r.classList.remove('rake--go'); void r.offsetWidth; r.classList.add('rake--go'); }
      rakeIO.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -22% 0px', threshold: 0 });
  SECTIONS.forEach(function (s) { rakeIO.observe(s); });

  /* ---------- 3. hero parallax ---------- */
  var hero = document.querySelector('.hero');
  var heroImg = hero && hero.querySelector('.hero__media img');
  var heroInner = hero && hero.querySelector('.hero__inner');
  if (heroImg || heroInner) {
    var ticking = false;
    var onScroll = function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var y = window.pageYOffset || document.documentElement.scrollTop;
        if (y > window.innerHeight * 1.4) return;
        if (heroImg) heroImg.style.setProperty('--heroY', (y * 0.22) + 'px');
        if (heroInner) heroInner.style.setProperty('--heroInnerY', (y * -0.09) + 'px');
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
})();
